<template lang="html">
  <div class="row px-4 py-5">
    <div class="col-lg-12 col-md-12 pr-5">
      <h3 class="mb-4 text-center">Info utente:</h3>
      <!-- <b>{{ form.user.full_name }}</b> ..-->
      <hr class="my-5">
      <h3 class="mb-4 text-center">Modifica richiesta:</h3>
      <b-form @submit.prevent="save">
        <div class="row">
          <div class="col-6">
            <b-form-group label="Quantità:">
              <b-form-input v-model="form.quantity" number required :disabled="form.is_locked || disabled"/>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Stato:">
              <b-select v-model="form.status" :disabled="disabled">
                <option v-for="status in $store.order_statuses" :key="status" :value="status">
                  {{ $t('order_status.' + status) }}
                </option>
              </b-select>
            </b-form-group>
          </div>
          <div class="col-6" v-if="$store.user.type == 'admin'">
            <b-form-group label="Partner:">
              <b-select v-model="user_id" :disabled="form.is_locked || $store.user.type != 'admin'">
                <option v-for="user in users" :key="user.id" :value="user.id">
                  {{ user.full_name }}
                </option>
              </b-select>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Prodotto:">
              <b-select v-model="form.product_id" :disabled="form.is_locked || disabled">
                <option v-for="prod in vis_prods" :key="prod.id" :value="prod.id">
                  <template v-if="!prod.is_varie">
                    {{ prod.product_type.code }}
                    /
                    {{ prod.name }}
                  </template>
                  <template v-else>
                    Varie
                    /
                    {{ prod.name }}
                  </template>


                </option>
              </b-select>
            </b-form-group>
          </div>

        </div>

        <div class="row" v-if="product">
          <div class="col-lg-12">
            Info prodotto:
            <ul>
              <li>Nome: {{product.name}}</li>
              <li>Tipologia: {{product.product_type.code}}</li>
              <li>Lato corto: {{product.product_type.side_a}}</li>
              <li>Lato lungo: {{product.product_type.side_b}}</li>
              <li>Peso (Kg): {{product.product_type.weight}}</li>
              <li>Portata (Kg): {{product.product_type.weight_range}}</li>
            </ul>
            <div>
              <b-button variant="primary">Riordina</b-button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="intestazione-tipo-mail">
              Documento Offerta:
            </div>
            <div class="sezione-documenti">
              <div class="sezione-sinistra">
                <div class="indicazione-label">
                  Carica un documento
                </div>

                <b-form-group >
                  <file-uploader class="allegati"
                  v-model="form.attachments"
                  accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                  :disabled="$store.user.type != 'admin'"
                  :params="{ type : 'ORD' , request_mode : 'true' }"/>
                </b-form-group>

              </div>
              <div class="sezione-destra" v-if="$store.user.type == 'admin'">
                <div class="">
                  Completa il corpo della mail
                </div>
                <div class="mail-text">
                  <b-form-textarea
                  v-model="form.offerBody"
                  :required="form.status == 'pending'"
                  rows="3"
                  ></b-form-textarea>
                </div>
                <div class="template-email">
                  Template:<br>

                  Buongiorno {{form.product.user.name}} {{form.product.user.surname}},<br>
                  come da gentile richiesta invio in allegato l'offerta n. {{form.proto }} e le foto indicative
                  dei pallet proposti.<br>
                  <br>
                  Resto a disposizione per ogni
                  eventuale chiarimento<br>

                  Cordiali saluti
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="intestazione-tipo-mail">
              Documento Ordine di Vendita:
            </div>
            <div class="sezione-documenti">
              <div class="sezione-sinistra">
                <div class="indicazione-label">
                  Carica un documento
                </div>

                <b-form-group label="Ord.Vendita">
                  <file-uploader class="allegati"
                  v-model="form.attachments"
                  accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                  :disabled="$store.user.type != 'admin'"
                  :params="{ type : 'ODV', request_mode : 'true' }"/>
                </b-form-group>

              </div>
              <div class="sezione-destra" v-if="$store.user.type == 'admin'">
                <div class="">
                  Completa il corpo della mail
                </div>
                <div class="mail-text">
                  <b-form-textarea
                  v-model="form.sellBody"
                  :required="form.status == 'accepted'"
                  rows="3"
                  ></b-form-textarea>
                </div>
                <div class="template-email">
                  Template:<br>

                  Buon giorno {{form.user.name}} {{form.user.surname}},<br>
                  in allegato invio ns. ordine n°{{form.proto}}.<br>
                  Aspetto gentile conferma, se ci sono variazioni
                  sulla data di consegna vanno segnalate
                  e concordate. Grazie<br>
                  Cordiali Saluti
                </div>

              </div>

            </div>
          </div>
          <div class="col-lg-12" v-if="$store.user.type == 'admin'">
            <div class="intestazione-tipo-mail">
              Documento Ordine di Acquisto:
            </div>
            <div class="sezione-documenti">
              <div class="sezione-sinistra">
                <div class="indicazione-label">
                  Carica un documento
                </div>

                <b-form-group label="Ord.Acquisto">
                  <file-uploader class="allegati"
                  v-model="form.attachments"
                  accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                  :disabled="$store.user.type != 'admin'"
                  :request_mode = 'true'
                  :params="{ type : 'ODA', request_mode : 'true' }"/>
                </b-form-group>

              </div>
              <div class="sezione-destra" v-if="$store.user.type == 'admin'">
                <div class="">
                  Completa il corpo della mail
                </div>
                <div class="mail-text">
                  <b-form-textarea
                  v-model="form.buyBody"
                  :required="form.status == 'accepted'"
                  rows="3"
                  ></b-form-textarea>
                </div>
                <div class="template-email">
                  Template:<br>

                  Buongiorno {{form.product.user.name}} {{form.product.user.surname}},<br>
                  Grazie per l'ordine, in allegato invio<br>
                  la ns. conferma n. {{form.proto}}.<br>
                  Il Totale da pagare comprensivo di Iva (se dovuta)
                  e contributo Conai è di € <br>
                  Cordiali saluti
                </div>
              </div>

            </div>
          </div>
        </div>


        <div class="text-center mt-4" v-if="$store.user.type != 'client'">
          <b-button variant="outline-danger" @click="$emit('close')" :disabled="is_saving">Annulla</b-button>
          &nbsp;
          <b-button type="submit" variant="primary" :disabled="is_saving || $store.user.type != 'admin'">Salva</b-button>
        </div>
      </b-form>
    </div>
    <div class="col comments" style="">
      <div class="row">
        <div class="col" v-if="['admin','client'].includes($store.user.type)">
          <order-chat :form="form" channel="client"/>
        </div>
        <div class="col" v-if="['admin','partner'].includes($store.user.type)">
          <order-chat :form="form" channel="partner"/>
        </div>
      </div>
    </div>
    <!-- <pre>
      {{form}}
    </pre> -->
  </div>
</template>

<script>
import FileUploader from '@/components/file-uploader'
import OrderChat from '@/components/order-chat'
import SweetalertManager from "@/SweetalertManager"

export default {
  components: {
    FileUploader,
    OrderChat,
  },
  props: ['form'],
  data() {
    return {
      users: [],
      user_id: this.form.product.user_id,
      is_saving: false
    }
  },
  computed: {
    active_user() {
      return this.users.find(x => x.id == this.user_id)
    },
    vis_prods() {
      if (!this.active_user) return []
      return this.active_user.products
    },
    disabled() {
      return this.$store.user.type != 'admin'
    },
    product(){
      if(!this.form.product_id) return null
      return this.vis_prods.find(x => x.id == this.form.product_id)
    }
  },
  created() {
    this.refreshUsers()
  },
  methods: {
    save() {

      console.log(this.form)

      if (this.form.status === 'pending' && !this.isDocumentPendingOrder()) {
        SweetalertManager.showAlert(this.$swal, {
          text: 'Allegare il Documento Offerta per salvare.',
          lang: 'it'
        })
        return
      }

      if (this.form.status === 'accepted' && !this.isDocumentsAcceptedOrder()) {
        SweetalertManager.showAlert(this.$swal, {
          text: 'Allegare i documenti Ordine di Vendita e Ordine di Acquisto per salvare.',
          lang: 'it'
        })
        return
      }

      this.is_saving = true
      this.$http.post('orders', this.form).then(res => {
        this.$emit('saved', res.data)
        this.$emit('close')
      }).finally(() => {
        this.is_saving = false
      })
    },
    isDocumentPendingOrder() {
        return (this.form.attachments.length > 0 && this.form.attachments.find(item => item.attachment_type === 'ORD'))
    },
    isDocumentsAcceptedOrder() {
        return (this.form.attachments.length > 0 && this.form.attachments.find(item => item.attachment_type === 'ODV') &&
            this.form.attachments.find(item => item.attachment_type === 'ODA'))
    },
    refreshUsers() {
      this.$http.get('users', {
        params: {
          with_prods: true
        }
      }).then(res => {
        this.users = res.data
        console.log(res.data)
      })
    },
  },
}
</script>

<style>

@media only screen and (max-width: 991px) {
  .reverse {
    flex-direction: column-reverse;
  }

  .comments {
    padding-top: 80px;
    border-left: 0px solid !important;
  }

  .coment-area {
    min-height: 200px;
  }
}

.lista-documenti{
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top:40px;
}


.comments {
  padding-top: 30px;
}

.allegati .file-box {
  display: flex !important;
  justify-content: flex-start;
  align-items: center;
}

.sezione-documenti{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction:row;
  border-bottom:1px solid #f1f1f1;
}
.sezione-sinistra, .sezione-destra{
  width:50%;
}
.intestazione-tipo-mail{
  width:100%;
  text-align: center;
  padding-top:20px;
  padding-bottom:20px;
}

</style>
